import { Component, OnInit } from '@angular/core';
import {} from '@fortawesome/fontawesome-common-types';
@Component({
  selector: 'app-skills',
  templateUrl: './skills.component.html',
  styleUrls: ['./skills.component.css']
})
export class SkillsComponent implements OnInit {

  constructor() { }

  formatLabel(value: number) {
    return value + '%';
  }

  ngOnInit(): void {
  }

}
